
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hsn-code/search",
      function () {
        return require("private-next-pages/hsn-code/search/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hsn-code/search"])
      });
    }
  